"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function convertObjectToKV(obj) {
    return Object.keys(obj).map(function (key) { return ({
        key: key,
        value: obj[key],
    }); });
}
exports.convertObjectToKV = convertObjectToKV;
// tslint:disable-next-line:no-any
function someToKv(kvs, value, prefix) {
    if (value == null) {
        kvs.push({
            key: prefix,
            value: String(value),
        });
    }
    else if (typeof value === 'object') {
        objectToKv(kvs, value, prefix + ".");
    }
    else if (Array.isArray(value)) {
        arrayToKv(kvs, value, prefix + ".");
    }
    else if (typeof value === 'function') {
        var name = value.name ? ' ' + value.name : '';
        kvs.push({
            key: prefix,
            value: "[Function" + name + "]",
        });
    }
    else {
        kvs.push({
            key: prefix,
            value: String(value),
        });
    }
    return kvs;
}
// tslint:disable-next-line:no-any
function objectToKv(kvs, obj, prefix) {
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        someToKv(kvs, value, "" + prefix + key);
    });
    return kvs;
}
// tslint:disable-next-line:no-any
function arrayToKv(kvs, arr, prefix) {
    arr.forEach(function (value, index) {
        someToKv(kvs, value, "" + prefix + index);
    });
    return kvs;
}
// tslint:disable-next-line:no-any
function convertDeepObjectToKV(obj) {
    return objectToKv([], obj, '');
}
exports.convertDeepObjectToKV = convertDeepObjectToKV;
//# sourceMappingURL=object_to_kv.js.map